import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const impactSummaryGraphApi = createAsyncThunk(
    'auth/ImpactSummaryGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { type, params } = requestData;
            const response = await AuthAxios.get(apiRoutes.impactSummaryGraph(`${type}`), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "" }

const impactSummaryGraphSlice = createSlice({
    name: 'ImpactSummaryGraph/graph',
    initialState: initialState,
    reducers: {
        resetImpactSummaryGraph: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(impactSummaryGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(impactSummaryGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(impactSummaryGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetImpactSummaryGraph } = impactSummaryGraphSlice.actions;
export const impactSummaryGraphReducer = impactSummaryGraphSlice.reducer